var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhgjStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1856,
    height: 820,
    viewBox: "0 0 1856 820",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 320 106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitcomm_logo-2",
    "data-name": "Bitcomm_logo",
    transform: "translate(45 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(35.597 0.608) rotate(45)",
    fill: "#0e86d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50.90496444702148 50.90496444702148 L 1.887659072875977 49.62485504150391 L 0.6075512766838074 0.6075512766838074 L 49.62485504150391 1.887659072875977 L 50.90496444702148 50.90496444702148 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.121135711669922 1.121135711669922 L 2.375099182128906 49.13741683959961 L 50.39138031005859 50.39138031005859 L 49.13741683959961 2.375099182128906 L 1.121135711669922 1.121135711669922 M 0.09396743774414062 0.09396743774414062 L 50.11229705810547 1.400218963623047 L 51.41854858398438 51.41854858398438 L 1.400218963623047 50.11229705810547 L 0.09396743774414062 0.09396743774414062 Z",
    stroke: "none",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(19.204 19.74)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 17.799,
    ry: 18.753,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 15.299,
    ry: 16.253,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M.568-1.031h0s8.95,7.449,10.283,9.924a47.609,47.609,0,0,1,2.316,5.086",
    transform: "translate(9.332 30.117)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(16.001 22.307) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M.143,5.135.455.013l14.3.812,2.286,4.348L15.152,5.2Z",
    transform: "translate(0.54 0.509)",
    fill: "#0e86d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1.448,1.027,1.2,5.165l14.469.058L16.8,5.209,15,1.8,1.448,1.027M.542.015,15.58.869l2.778,5.284-2.639.033L.171,6.123Z",
    transform: "translate(0 0)",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    "data-name": "Path 3",
    transform: "matrix(0.616, -0.788, 0.788, 0.616, 7.56, 30.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M3.893.459-.014.5,0,0,3.893.366Z",
    transform: "translate(0.473 0.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M.013,0,4.85.455v1l-4.892.051Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M44,44",
    transform: "translate(-3.719 31.506)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 1.481)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 31.584)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 26.649)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(9.368 21.714)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(69.789) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-2",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-2",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-2",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-2",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-2",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571 0)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-2",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-2",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(70.258 73.532) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-3",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 27.636)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-3",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(8.431 22.701)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-3",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-3",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-3",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-3",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-3",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(34.192 37.506) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-4",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-4",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-4",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-4",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-4",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-3",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-4",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571 0)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-4",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-4",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-NHGJ"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1856,
    height: 820
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NHGJ",
    clipPath: "url(#clip-NHGJ)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1856,
    height: 820,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "YardLayout"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BlackCanvas",
    width: 1856,
    height: 820
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stationinfo",
    transform: "translate(838 29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H180",
    transform: "translate(0 49.216)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\\\\\\\u0928\\\\\\\\u0908_\\\\\\\\u0939\\\\\\\\u093E\\\\\\\\u0930\\\\\\\\u093E\\\\\\\\u0902\\\\\\\\u0917\\\\\\\\u093E\\\\\\\\u091C\\\\\\\\u093E\\\\\\\\u0913",
    "data-name": "\\\\\\\\u0928\\\\\\\\u0908 \\\\\\\\u0939\\\\\\\\u093E\\\\\\\\u0930\\\\\\\\u093E\\\\\\\\u0902\\\\\\\\u0917\\\\\\\\u093E\\\\\\\\u091C\\\\\\\\u093E\\\\\\\\u0913",
    transform: "translate(90 31)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "NirmalaUI, Nirmala UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -90.447,
    y: 0
  }, "\n\t\t\t\t\t\t\u0928\u0908\n\t\t\t\t\t"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "SegoeUI, Segoe UI"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "\n\t\t\t\t\t\t\u0939\u093E\u0930\u093E\u0902\u0917\u093E\u091C\u093E\u0913\n\t\t\t\t\t")), /*#__PURE__*/React.createElement("text", {
    id: "New_Harangajao",
    "data-name": "New Harangajao",
    transform: "translate(90 81)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -110.149,
    y: 0
  }, "\n\t\t\t\t\t\tNew Harangajao\n\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "Legend",
    transform: "translate(1391.246 656.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegend",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PMLegendLabel",
    transform: "translate(11 19)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tPOINT MACHINE\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormal",
    transform: "translate(11 25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormalIndicator",
    fill: "none",
    stroke: "#21e074",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendNormalLabel",
    transform: "translate(32 16)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tNORMAL\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverse",
    transform: "translate(11 49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverseIndicator",
    fill: "none",
    stroke: "#0088d1",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendReverseLabel",
    transform: "translate(30 15)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tREVERSE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendHr",
    transform: "translate(11.929 69.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr1",
    d: "M10.433,19.646C4.823,15.724,1.881,12.155.675,9.168c-3.232-8,6-11.832,9.758-7.107,3.758-4.725,12.991-.9,9.758,7.107C18.985,12.155,16.043,15.724,10.433,19.646Z",
    transform: "translate(0 3.457)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr2",
    d: "M-.094.01H5.175L7.357-3.307l2.832,6.271L12.232.01,19.327,0",
    transform: "translate(0.807 12.769)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendFailureLabel",
    transform: "translate(28.702 15)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFAILURE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendCanvas",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 124,
    height: 107,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegend",
    transform: "translate(181)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCLegendLabel",
    transform: "translate(22 19)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tTRACKCIRCUIT\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "TCFreeLegendGroup",
    transform: "translate(10.5 28.494)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFreeLegendIndicator",
    x2: 70,
    transform: "translate(0 9.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFreeLegendLabel",
    transform: "translate(77.5 15)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFREE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOccupiedLegendGroup",
    transform: "translate(10.5 51.439)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOccupiedLegendIndicator",
    x2: 70,
    transform: "translate(0 9.5)",
    fill: "none",
    stroke: "#e77e00",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOccupiedLegendLabel",
    transform: "translate(76.921 15)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tOCCUPIED\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCFailureLLegendGroup",
    transform: "translate(10.5 72.539)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFailureLegendIndicator",
    x2: 70,
    transform: "translate(0 9.5)",
    fill: "none",
    stroke: "red",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFailureLLegendLabel",
    transform: "translate(79 15)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFAILURE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegendCanvas",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 157,
    height: 107,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Signal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS3",
    className: "tooltip",
    transform: "translate(201.266 262.889) rotate(-0.3)",
    "edge-id": "NHGJ_SG_S3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS3Label",
    transform: "translate(15.866 -5.686)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-3\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect2",
    transform: "translate(7.753 -3.65)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S3Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect1",
    transform: "translate(22.753 -3.572)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S3Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS37",
    className: "tooltip",
    transform: "translate(912.339 356.763) rotate(179.7)",
    "edge-id": "NHGJ_SG_S37"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS37Label",
    transform: "translate(48.548 23.097) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S37Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-37\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS37Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S37Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS37Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S37Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS35",
    className: "tooltip",
    transform: "translate(980.339 281.724) rotate(179.7)",
    "edge-id": "NHGJ_SG_S35"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS35Label",
    transform: "translate(48.548 23.097) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S35Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-35\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS35Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S35Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS35Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S35Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS14",
    className: "tooltip",
    transform: "translate(655.429 354.724) rotate(179.7)",
    "edge-id": "NHGJ_SG_S14"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS14Label",
    transform: "translate(48.548 23.097) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S14Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-14\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS14Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S14Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS14Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S14Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS39",
    className: "tooltip",
    transform: "translate(965.227 210.186) rotate(179.7)",
    "edge-id": "NHGJ_SG_S39"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS39Label",
    transform: "translate(48.548 23.097) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S39Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-39\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS39Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S39Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS39Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S39Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS2",
    className: "tooltip",
    transform: "translate(351.085 284.397) rotate(179.7)",
    "edge-id": "NHGJ_SG_S2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS2Label",
    transform: "translate(45.543 24.082) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-2\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS2Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S2Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS2Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S2Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES",
    transform: "translate(51.42 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1",
    y2: 13.952,
    transform: "translate(7.972 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS12",
    className: "tooltip",
    transform: "translate(702.864 283.186) rotate(179.7)",
    "edge-id": "NHGJ_SG_S12"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS12Label",
    transform: "translate(48.548 23.097) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S12Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-12\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS12Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S12Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS12Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S12Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC3",
    className: "tooltip",
    transform: "translate(217.995 283.823) rotate(179.7)",
    "edge-id": "NHGJ_SG_C3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC3abel",
    transform: "translate(28.057 35.463) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_C3abel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n\t\t\t\t\t\t\tC-3\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGC3Aspect",
    transform: "translate(14.117 11.39)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_C3Aspect"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 5,
    ry: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 4.25,
    ry: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-2",
    "data-name": "POLES",
    transform: "translate(9.146 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-2",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(24.585 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-2",
    "data-name": "POLES2",
    x2: 10,
    transform: "translate(14.5 16.28)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3",
    x2: 5,
    transform: "translate(0 16.23)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS16",
    className: "tooltip",
    transform: "translate(680.147 210.186) rotate(179.7)",
    "edge-id": "NHGJ_SG_S16"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS16Label",
    transform: "translate(48.548 23.097) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S16Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-16\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS16Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S16Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS16Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S16Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS46",
    className: "tooltip",
    transform: "translate(1345.177 274.57) rotate(179.7)",
    "edge-id": "NHGJ_SG_S46"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS46Label",
    transform: "translate(24.968 17.131) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S46Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-46\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect2",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S46Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect1",
    transform: "translate(15.078 0.079)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S46Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC46",
    className: "tooltip",
    transform: "translate(1314.942 283.247) rotate(179.7)",
    "edge-id": "NHGJ_SG_C46"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC46Label",
    transform: "translate(24.964 35.542) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_C46Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n\t\t\t\t\t\t\tC-46\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGC46Aspect",
    transform: "translate(2.012 11.422)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_C46Aspect"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 5,
    ry: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 4.25,
    ry: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-3",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-3",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(16.585 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-3",
    "data-name": "POLES2",
    x2: 5,
    transform: "translate(11.585 16.307)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-2",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(0 16.22)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS47",
    className: "tooltip",
    transform: "translate(1287.011 282.689) rotate(179.7)",
    "edge-id": "NHGJ_SG_S47"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS47Label",
    transform: "translate(48.926 24.099) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_S47Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-47\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS47Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S47Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS47Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NHGJ_SG_S47Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-4",
    "data-name": "POLES",
    transform: "translate(51.42 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-4",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-4",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Shunt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SH44",
    className: "tooltip",
    transform: "translate(1142 249.781)",
    "edge-id": "NHGJ_SG_SH44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole",
    transform: "translate(0 20.219)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH44Pole1",
    y1: 15,
    transform: "translate(0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH44Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH44Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH44Pole2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH44Aspect1",
    transform: "translate(5 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH44Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH44Aspect2",
    transform: "translate(16 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH44Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH44Aspect3",
    transform: "translate(27 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH44Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH44Label",
    transform: "translate(4.5 13)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_SH44Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-44\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH37",
    className: "tooltip",
    transform: "translate(819.819 321.781)",
    "edge-id": "NHGJ_SG_SH37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-2",
    "data-name": "Pole",
    transform: "translate(0 20.187)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH37Pole1",
    y1: 15.032,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH37Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH37Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH37Pole2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-3",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(40.181 -0.402) rotate(179.7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH37Aspect1",
    transform: "translate(5 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH37Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH37Aspect2",
    transform: "translate(16 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH37Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH37Aspect3",
    transform: "translate(27 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH37Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH37Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_SH37Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-37\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH35",
    className: "tooltip",
    transform: "translate(887.819 248.781)",
    "edge-id": "NHGJ_SG_SH35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-3",
    "data-name": "Pole",
    transform: "translate(0 20.187)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH35Pole1",
    y1: 15.032,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH35Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH35Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH35Pole2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-4",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(40.181 -0.402) rotate(179.7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH35Aspect1",
    transform: "translate(5 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH35Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH35Aspect2",
    transform: "translate(16 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH35Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH35Aspect3",
    transform: "translate(27 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH35Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH35Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_SH35Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-35\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH39",
    className: "tooltip",
    transform: "translate(872.91 175.204)",
    "edge-id": "NHGJ_SG_SH39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-4",
    "data-name": "Pole",
    transform: "translate(0 20.187)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH39Pole1",
    y1: 15.032,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH39Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH39Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH39Pole2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-5",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(40.181 -0.402) rotate(179.7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH39Aspect1",
    transform: "translate(5 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH39Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH39Aspect2",
    transform: "translate(16 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH39Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH39Aspect3",
    transform: "translate(27 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH39Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH39Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_SH39Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-39\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH14",
    className: "tooltip",
    transform: "translate(562.91 320.673)",
    "edge-id": "NHGJ_SG_SH14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-5",
    "data-name": "Pole",
    transform: "translate(0 20.187)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH14Pole1",
    y1: 15.032,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH14Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH14Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH14Pole2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-6",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(40.181 -0.402) rotate(179.7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH14Aspect1",
    transform: "translate(5 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH14Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH14Aspect2",
    transform: "translate(16 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH14Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH14Aspect3",
    transform: "translate(27 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH14Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH14Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_SH14Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-14\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH7",
    className: "tooltip",
    transform: "translate(413 248.781)",
    "edge-id": "NHGJ_SG_SH7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-6",
    "data-name": "Pole",
    transform: "translate(0 20.219)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1",
    y1: 15,
    transform: "translate(0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH7Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH7Pole2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH7Aspect1",
    transform: "translate(5 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH7Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH7Aspect2",
    transform: "translate(16 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH7Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH7Aspect3",
    transform: "translate(27 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH7Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH7Label",
    transform: "translate(7.5 13)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_SH7Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-7\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH12",
    className: "tooltip",
    transform: "translate(610.344 248.781)",
    "edge-id": "NHGJ_SG_SH12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-7",
    "data-name": "Pole",
    transform: "translate(0 20.187)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH12Pole1",
    y1: 15.032,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH12Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH12Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH12Pole2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-7",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(40.181 -0.402) rotate(179.7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH12Aspect1",
    transform: "translate(5 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH12Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH12Aspect2",
    transform: "translate(16 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH12Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH12Aspect3",
    transform: "translate(27 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH12Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH12Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_SH12Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-12\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH16",
    className: "tooltip",
    transform: "translate(587.344 175.781)",
    "edge-id": "NHGJ_SG_SH16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-8",
    "data-name": "Pole",
    transform: "translate(0 20.187)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH16Pole1",
    y1: 15.032,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH16Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH16Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NHGJ_SG_SH16Pole2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-8",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(40.181 -0.402) rotate(179.7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH16Aspect1",
    transform: "translate(5 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH16Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH16Aspect2",
    transform: "translate(16 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH16Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH16Aspect3",
    transform: "translate(27 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_SG_SH16Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH16Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_SG_SH16Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-16\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TrackCircuit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TC112T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_112T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC112TLine",
    x1: 267,
    transform: "translate(923 357)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_112TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC112TLabel",
    transform: "translate(1033 369)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_112TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n\t\t\t\t\t\t\t112T\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TC112TPOLES",
    y1: 10,
    transform: "translate(1190 352)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_112TPOLES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TC102T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_102T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC102TLine",
    x1: 239,
    transform: "translate(429 211)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_102TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC102TLabel",
    transform: "translate(534 206)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_102TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n\t\t\t\t\t\t\t102T\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TC102TPOLES",
    y1: 10,
    transform: "translate(429 206)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_102TPOLES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TCC46T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_C46T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC46TLine",
    x1: 162,
    transform: "translate(1324 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_C46TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC46TLabel",
    transform: "translate(1408 296)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_C46TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.802,
    y: 0
  }, "\n\t\t\t\t\t\t\tC46T\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TCC46TPOLES",
    y1: 10,
    transform: "translate(1486 279)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_C46TPOLES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TC47AT",
    className: "tooltip",
    "edge-id": "NHGJ_TC_47AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC47ATLine",
    x1: 48,
    transform: "translate(1190 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_47ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC47ATLabel",
    transform: "translate(1210 281)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_47ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.813,
    y: 0
  }, "\n\t\t\t\t\t\t\t47AT\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TC111TLine",
    x1: 129,
    transform: "translate(1058 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TC46T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_46T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC46TLine",
    x1: 80,
    transform: "translate(1241 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_46TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC46TLabel",
    transform: "translate(1265 295)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_46TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.332,
    y: 0
  }, "\n\t\t\t\t\t\t\t46T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC111T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_111T"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TC111TLabel",
    transform: "translate(1116 281)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_111TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n\t\t\t\t\t\t\t111T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC113T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_113T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC113TLine",
    x1: 129,
    transform: "translate(926 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_113TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC113TLabel",
    transform: "translate(994 281)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_113TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n\t\t\t\t\t\t\t113T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC114T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_114T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC114TLine",
    x1: 171,
    transform: "translate(923 211)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_114TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC114TLabel",
    transform: "translate(979 208)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_114TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n\t\t\t\t\t\t\t114T\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TC114TPOLES",
    y1: 10,
    transform: "translate(1095 206)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_114TPOLES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TCOB2T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_OB2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOB2TLine",
    x1: 129,
    transform: "translate(791 211)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_OB2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOB2TLabel",
    transform: "translate(833 208)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_OB2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.035,
    y: 0
  }, "\n\t\t\t\t\t\t\tOB2T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOA1T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_OA1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOA1TLine",
    x1: 129,
    transform: "translate(662 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_OA1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOA1TLabel",
    transform: "translate(713 281)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_OA1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.951,
    y: 0
  }, "\n\t\t\t\t\t\t\tOA1T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOA2T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_OA2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOA2TLine",
    x1: 129,
    transform: "translate(794 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_OA2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOA2TLabel",
    transform: "translate(848 281)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_OA2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.951,
    y: 0
  }, "\n\t\t\t\t\t\t\tOA2T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOC1T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_OC1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOC1TLine",
    x1: 80,
    transform: "translate(730 357)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_OC1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOC1TLabel",
    transform: "translate(762 354)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_OC1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.941,
    y: 0
  }, "\n\t\t\t\t\t\t\tOC1T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOC2T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_OC2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOC2TLine",
    x1: 107,
    transform: "translate(813 357)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_OC2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOC2TLabel",
    transform: "translate(846 369)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_OC2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.941,
    y: 0
  }, "\n\t\t\t\t\t\t\tOC2T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOB1T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_OB1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOBITLine",
    x1: 117,
    transform: "translate(671 211)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOB1TLabel",
    transform: "translate(716 208)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_OB1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.035,
    y: 0
  }, "\n\t\t\t\t\t\t\tOB1T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCC3T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_C3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC3TLine",
    x1: 124,
    transform: "translate(100 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_C3TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC3TLabel",
    transform: "translate(178 296)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_C3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.657,
    y: 0
  }, "\n\t\t\t\t\t\t\tC3T\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TCC3TPOLES",
    y1: 10,
    transform: "translate(100 279)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_C3TPOLES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TC3T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3TLine",
    x1: 129,
    transform: "translate(227 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_3TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3TLabel",
    transform: "translate(279 296)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.188,
    y: 0
  }, "\n\t\t\t\t\t\t\t3T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC2AT",
    className: "tooltip",
    "edge-id": "NHGJ_TC_2AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC2ATLine",
    x1: 36,
    transform: "translate(359 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_2ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC2ATLabel",
    transform: "translate(373 281)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_2ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.668,
    y: 0
  }, "\n\t\t\t\t\t\t\t2AT\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC101T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_101T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC101TLine",
    x1: 129,
    transform: "translate(398 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_101TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC101TLabel",
    transform: "translate(451 296)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_101TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n\t\t\t\t\t\t\t101T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC103T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_103T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC103TLine",
    x1: 129,
    transform: "translate(530 284)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_103TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC103TLabel",
    transform: "translate(590 281)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_103TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n\t\t\t\t\t\t\t103T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC104T",
    className: "tooltip",
    "edge-id": "NHGJ_TC_104T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC104TLine",
    x1: 178,
    transform: "translate(549 357)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_104TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC104TLabel",
    transform: "translate(595 369)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_TC_104TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n\t\t\t\t\t\t\t104T\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TC104TPOLES",
    y1: 10,
    transform: "translate(549 352)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    "edge-id-selector": "NHGJ_TC_104TPOLES"
  })), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER1Line",
    d: "M134.059-2.449H122.295L-7.3,58.9H-20.148",
    transform: "translate(533.941 219.193)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER3Line",
    d: "M129.213,53.264h-9.65L8.72-9.674H-2.63",
    transform: "translate(925.63 225.185)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER4Line",
    d: "M111.969-2.449H101.891L-9.137,60.71h-11.01",
    transform: "translate(943.148 291.543)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER2Line",
    d: "M-5.991-2.779H8.7L63.56,60.98H77.284",
    transform: "translate(649.716 291.273)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PointMachine"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM101",
    className: "tooltip",
    transform: "translate(511.518 238.597)",
    "edge-id": "NHGJ_PM_101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM101Hr",
    transform: "translate(-8.054 23.266) rotate(-0.3)",
    "edge-id-selector": "NHGJ_PM_101Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM101Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "NHGJ_PM_101Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM101Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NHGJ_PM_101Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM101Icon",
    transform: "translate(3.482 21.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NHGJ_PM_101Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM101Label",
    transform: "translate(2.482 19.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_PM_101Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t101\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM102",
    className: "tooltip",
    transform: "translate(649.99 195.27)",
    "edge-id": "NHGJ_PM_102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM102Hr",
    transform: "translate(19.278 26.266) rotate(-0.3)",
    "edge-id-selector": "NHGJ_PM_102Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM102Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "NHGJ_PM_102Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM102Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NHGJ_PM_102Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM102Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NHGJ_PM_102Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM102Label",
    transform: "translate(2.482 49.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_PM_102Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t102\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM104",
    className: "tooltip",
    transform: "translate(710.185 313.354)",
    "edge-id": "NHGJ_PM_104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM104Hr",
    transform: "translate(19.944 23.266) rotate(-0.3)",
    "edge-id-selector": "NHGJ_PM_104Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM104Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "NHGJ_PM_104Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM104Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NHGJ_PM_104Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM104Icon",
    transform: "translate(3.482 21.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NHGJ_PM_104Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM104Label",
    transform: "translate(1.482 19.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_PM_104Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t104\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM103",
    className: "tooltip",
    transform: "translate(641.243 267.596)",
    "edge-id": "NHGJ_PM_103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM103Hr",
    transform: "translate(-7.722 26.266) rotate(-0.3)",
    "edge-id-selector": "NHGJ_PM_103Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM103Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "NHGJ_PM_103Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM103Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NHGJ_PM_103Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM103Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NHGJ_PM_103Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM103Label",
    transform: "translate(2.482 48.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_PM_103Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t103\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM114",
    className: "tooltip",
    transform: "translate(918.518 194.354)",
    "edge-id": "NHGJ_PM_114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM114Hr",
    transform: "translate(-7.054 26.266) rotate(-0.3)",
    "edge-id-selector": "NHGJ_PM_114Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM114Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "NHGJ_PM_114Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM114Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NHGJ_PM_114Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM114Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NHGJ_PM_114Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM114Label",
    transform: "translate(2.482 48.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_PM_114Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t114\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM113",
    className: "tooltip",
    transform: "translate(1037.718 239.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM113Hr",
    transform: "translate(19.944 23.266) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM113Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM113Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM113Icon",
    transform: "translate(3.482 21.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM113Label",
    transform: "translate(2.482 19.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t113\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM111",
    className: "tooltip",
    transform: "translate(1039.384 267.527)",
    "edge-id": "NHGJ_PM_111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM111Hr",
    transform: "translate(19.278 26.266) rotate(-0.3)",
    "edge-id-selector": "NHGJ_PM_111Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM111Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "NHGJ_PM_111Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM111Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NHGJ_PM_111Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM111Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NHGJ_PM_111Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM111Label",
    transform: "translate(3.482 48.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_PM_111Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t111\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM112",
    className: "tooltip",
    transform: "translate(918.852 313.597)",
    "edge-id": "NHGJ_PM_112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM112Hr",
    transform: "translate(-7.056 23.266) rotate(-0.3)",
    "edge-id-selector": "NHGJ_PM_112Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM112Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "NHGJ_PM_112Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM112Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NHGJ_PM_112Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM112Icon",
    transform: "translate(3.482 21.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NHGJ_PM_112Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM112Label",
    transform: "translate(1.482 19.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_PM_112Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t112\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "AXL",
    transform: "translate(-170 -42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXLBPCBPB2",
    className: "tooltip",
    transform: "translate(48 -10)",
    "edge-id": "NHGJ_AC_BPCBPB2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLBPCBPB2Label",
    transform: "translate(1352 593)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_AC_BPCBPB2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.454,
    y: 0
  }, "\n\t\t\t\t\t\t\tBPCBPB2\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "AXLBPCBPB2Icon",
    transform: "translate(1336 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_AC_BPCBPB2Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLBPCBPB1",
    className: "tooltip",
    transform: "translate(105 -6)",
    "edge-id": "NHGJ_AC_BPCBPB1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLBPCBPB1Label",
    transform: "translate(1399 591)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_AC_BPCBPB1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.454,
    y: 0
  }, "\n\t\t\t\t\t\t\tBPCBPB1\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "AXLBPCBPB1Icon",
    transform: "translate(1389 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_AC_BPCBPB1Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLBPCLMG2",
    className: "tooltip",
    transform: "translate(164 -6)",
    "edge-id": "NHGJ_AC_BPCLMG2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLBPCLMG2Label",
    transform: "translate(1452 592)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_AC_BPCLMG2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.218,
    y: 0
  }, "\n\t\t\t\t\t\t\tBPCLMG2\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "AXLBPCLMG2Icon",
    transform: "translate(1444 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_AC_BPCLMG2Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 26,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLBPCLMG1",
    className: "tooltip",
    transform: "translate(220 -5)",
    "edge-id": "NHGJ_AC_BPCLMG1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLBPCLMG1Label",
    transform: "translate(1510 591)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NHGJ_AC_BPCLMG1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.519,
    y: 0
  }, "\n\t\t\t\t\t\t\tBPCLMG1\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "AXLBPCLMG1Icon",
    transform: "translate(1502 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NHGJ_AC_BPCLMG1Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "AXLE_COUNTER",
    "data-name": "AXLE COUNTER",
    transform: "translate(1534 537)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -64.477,
    y: 0
  }, "\n\t\t\t\t\t\tAXLE COUNTER\n\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "AXLRectangle",
    transform: "translate(1307 507)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 483,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 480,
    height: 106,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "BITCOMM_LOGO",
    "data-name": "BITCOMM LOGO",
    width: 296,
    height: 98,
    transform: "translate(24 20)",
    fill: "url(#pattern)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhgjStation);
export default __webpack_public_path__ + "static/media/NHGJ_Station.05b7a5e2c4fd0cf7998836ac04a78ddb.svg";
export { ForwardRef as ReactComponent };